(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
function observeFadoCartDock(){
 const dock=document.querySelector('body.page-cart #main-cart-footer');
 if(!dock||dock.dataset.fadoMeasured)return;dock.dataset.fadoMeasured='true';
 new ResizeObserver(()=>document.body.style.setProperty('--fado-cart-dock-height',dock.hidden||dock.classList.contains('is-empty')?'0px':dock.getBoundingClientRect().height+'px')).observe(dock);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeFadoCartDock);else observeFadoCartDock();
document.addEventListener('fado:cart-rendered',observeFadoCartDock);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
function initFadoDarkReviews(){
 document.querySelectorAll('.fado-reviews-dark').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const track=root.querySelector('.fado-reviews-dark__track'),cards=Array.from(track.children),buttons=root.querySelectorAll('button[data-step]'),status=root.querySelector('[aria-live]');
  if(!cards.length)return;
  let frame=0;
  const update=()=>{frame=0;const max=track.scrollWidth-track.clientWidth;const step=cards[0].offsetWidth+20;let index=Math.round(track.scrollLeft/step);if(track.scrollLeft>=max-2)index=cards.length-1;status.textContent=(index+1)+' / '+cards.length;buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft>=max-2};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
  buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:(cards[0].offsetWidth+20)*Number(b.dataset.step),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll',schedule,{passive:true});new ResizeObserver(schedule).observe(track);update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFadoDarkReviews);else initFadoDarkReviews();
document.addEventListener('shopify:section:load',initFadoDarkReviews);

  } catch(e) { console.error(e); }
})();
})();
